<template>
    <div
        class="m-tabs"
        :class="{'m-tabs--center':center}"
    >
        <a-button
            v-for="item in items"
            v-bind:key="item.value || item.id"
            class="m-tabs__tab"
            :class="{'a-button--grey':item.value !== selected, 'm-tabs__tab--wide': wide}"
            @click="emit(item)"
        >
            {{ item.label || item.name}}
        </a-button>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        selected: {
            type: String,
            required: true
        },
        center: {
            type: Boolean,
            default: false
        },
        wide: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        emit(item) {
            this.$emit('input', item)
            this.current = item.value
        }
    }
}
</script>